const AUTH_KEY = 'auth'

export const removeAuthFromStorage = () => {
	localStorage.removeItem(AUTH_KEY)
}

export const setAuthInStorage = (auth: { access_token: string }) =>
	localStorage.setItem(AUTH_KEY, JSON.stringify(auth))

export const getAuthFromStorage = (): { access_token?: string } =>
	JSON.parse(localStorage.getItem(AUTH_KEY) || '{}')
